import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 820,
    margin: '0 auto',
  },
  cover: {
    display: 'block',
    width: '100%',
    maxHeight: 420,
    objectFit: 'cover',
    borderRadius: 10,
    marginBottom: theme.spacing(3),
  },
  title: {
    fontWeight: 'bold',
    fontSize: theme.typography.fontSize * 2.2,
    lineHeight: 1.2,
    marginBottom: theme.spacing(1),
    wordBreak: 'break-word',
  },
  content: {
    marginTop: theme.spacing(3),
    '& .ql-editor': {
      padding: 0,
      fontSize: 16,
      lineHeight: 1.7,
      overflow: 'visible',
      wordBreak: 'break-word',
    },
    '& .ql-editor img': {
      maxWidth: '100%',
      height: 'auto',
      borderRadius: 6,
    },
    '& .ql-editor .ql-video, & .ql-editor .ql-video-file': {
      display: 'block',
      width: '100%',
      aspectRatio: '16 / 9',
      margin: `${theme.spacing(2)}px auto`,
      borderRadius: 6,
      backgroundColor: '#000',
    },
    // Player do Spotify tem altura fixa: faixa/episódio compacto, demais (álbum, playlist...) maior.
    '& .ql-editor .ql-video[src*="open.spotify.com"]': {
      aspectRatio: 'auto',
      height: 352,
      maxWidth: 720,
      borderRadius: 12,
      backgroundColor: 'transparent',
    },
    '& .ql-editor .ql-video[src*="/embed/track/"], & .ql-editor .ql-video[src*="/embed/episode/"]': {
      height: 152,
    },
    '& .ql-editor a': {
      color: theme.palette.primary.main,
    },
  },
}));
